import { COMPONENT_VALUE_TYPES as types } from 'shared/constants';
import type { PropsSchemaList } from 'shared/types/PropsSchema';

export type AiGeneratedContent = {
  prompt?: string;
  images?: string[];
  inlineImages?: {
    name?: string;
    format?: string;
    base64?: string;
    size?: number;
  }[];
  html?: string;
  css?: string;
  js?: string;
  warnings?: string[];
  scopeClass?: string;
  /** 2 = pasted with the v2 tools and scoped by the v2 scoper. Unset = the original scoper. */
  scoper?: number;
  /** Set when an AI app wrote this through the connector, e.g. "Claude (connector)". Its script doesn't run on Genesis with a session until a person keeps the code in the editor (which clears this). */
  via?: string;
  /** Set only while Genesis renders a preview for someone signed in (never stored): the HTML is added in the browser. */
  deferHtml?: boolean;
  lastGeneratedAt?: string;
  model?: string;
};

export type Props = {
  content: AiGeneratedContent;
};

const propsSchema: PropsSchemaList = [
  {
    key: 'content',
    label: 'AI Generated Widget',
    type: types.AI_CODE_GENERATOR
  }
];

const defaultProps: Props = {
  content: {
    prompt: '',
    images: [],
    html: '',
    css: '',
    js: '',
    warnings: []
  }
};

export default {
  title: 'AI Generated Widget',
  id: 'AiGeneratedWidget',
  propsSchema,
  defaultProps
};
